import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "@/hooks/use-toast";
import { updateCouplesPackProfessional } from "../services/update-couples-pack-professional";

export function useUpdateCouplesPackProfessional() {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: ({
      professional_id,
      couples_pack_usage_identifier,
    }: {
      professional_id: string;
      couples_pack_usage_identifier: string;
    }) => updateCouplesPackProfessional({professional_id, couples_pack_usage_identifier}),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["couples-packs"], exact: false });
      toast({
        title: "Success",
        description: "Usage Identifier updated successfully",
      });
    },
    onError: (error: any) => {
      toast({
        title: "Error",
        description:
          error?.message || "Failed to update couples pack professional",
        variant: "destructive",
      });
    },
  });
}
